import { toString } from '@carbon/icon-helpers';

import AlignHorizontalLeft24 from '@carbon/icons/es/align--horizontal-left/24';
import AlignHorizontalRight24 from '@carbon/icons/es/align--horizontal-right/24';
import AlignVerticalTop24 from '@carbon/icons/es/align--vertical-top/24';
import AlignVerticalBottom24 from '@carbon/icons/es/align--vertical-bottom/24';
import AlignVerticalCenter24 from '@carbon/icons/es/align--vertical-center/24';
import AlignHorizontalCenter24 from '@carbon/icons/es/align--horizontal-center/24';
import BringToFront16 from '@carbon/icons/es/bring-to-front/16';
import BringToFront24 from '@carbon/icons/es/bring-to-front/24';
import Crop24 from '@carbon/icons/es/crop/24';
import FitToWidth from '@carbon/icons/es/fit-to-width/24';
import Replicate24 from '@carbon/icons/es/replicate/24';

const strAlignHorizontalLeft24 = toString(AlignHorizontalLeft24);
const strAlignHorizontalRight24 = toString(AlignHorizontalRight24);
const strAlignVerticalTop24 = toString(AlignVerticalTop24);
const strAlignVerticalBottom24 = toString(AlignVerticalBottom24);
const strAlignVerticalCenter24 = toString(AlignVerticalCenter24);
const strAlignHorizontalCenter24 = toString(AlignHorizontalCenter24);
const strBringToFront16 = toString(BringToFront16);
const strBringToFront24 = toString(BringToFront24);
const strCrop24 = toString(Crop24);
const strFitToWidth = toString(FitToWidth);
const strReplicate = toString(Replicate24);

export {
  strAlignHorizontalLeft24,
  strAlignHorizontalRight24,
  strAlignVerticalTop24,
  strAlignVerticalBottom24,
  strAlignVerticalCenter24,
  strAlignHorizontalCenter24,
  strBringToFront16,
  strBringToFront24,
  strCrop24,
  strFitToWidth,
  strReplicate,
};
